/* jshint browserify: true */
'use strict';

import trapFocusService from '../Services/trapFocus';

window._define('bridge/trapFocus', trapFocusService);
